import { render, staticRenderFns } from "./ExternalSourcesPage.vue?vue&type=template&id=658888b4&scoped=true"
import script from "./ExternalSourcesPage.vue?vue&type=script&lang=js"
export * from "./ExternalSourcesPage.vue?vue&type=script&lang=js"
import style0 from "./ExternalSourcesPage.vue?vue&type=style&index=0&id=658888b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658888b4",
  null
  
)

export default component.exports